import type { ReleaseNoteRow } from '@/lib/releaseNotes';

/** 서버가 저장한 노트 키 ↔ 판 한 줄 (V448). {@code lib/version.ts} 의 응답과 같은 모양이다. */
export type NoteLink = { noteKey: string; buildReleaseId: string | null; hidden: boolean };

/**
 * 「Job 버전별」 의 묶음 — 판 id 마다 그 판에 저장된 노트, 그리고 어느 판에도 못 붙은 노트.
 *
 * <h2>숨긴 것 말고는 하나도 빠지지 않는다 (사용자 지시 2026-10-14)</h2>
 * 「이제 진짜 Job 에 안 뜨는 거 없어야 해」. 줄은 셋 중 하나로만 간다 —
 * ① 감춤 ② 저장된 판이 목록에 있으면 그 판 ③ 그 밖(아직 보고 안 됨 · 판을 비움 · 판이 목록에 없음)은
 * {@code unassigned}. 「저장된 판이 목록에 없다」 를 따로 받는 것은, 그 줄을 판 id 로만 묶으면
 * 그리는 쪽이 그 id 를 찾지 못해 조용히 사라지기 때문이다.
 */
export function groupNotesByBuild(
  rows: readonly ReleaseNoteRow[],
  links: readonly NoteLink[],
  buildIds: ReadonlySet<string>,
): { byBuild: Map<string, ReleaseNoteRow[]>; unassigned: ReleaseNoteRow[] } {
  const byKey = new Map(links.map((link) => [link.noteKey, link]));
  const byBuild = new Map<string, ReleaseNoteRow[]>();
  const unassigned: ReleaseNoteRow[] = [];

  for (const row of rows) {
    const link = byKey.get(row.key);
    if (link?.hidden) continue;
    const buildId = link?.buildReleaseId;
    if (!buildId || !buildIds.has(buildId)) {
      unassigned.push(row);
      continue;
    }
    const list = byBuild.get(buildId) ?? [];
    list.push(row);
    byBuild.set(buildId, list);
  }
  return { byBuild, unassigned };
}
